export enum RepairTypes {
  /**
   * Блочный
   */
  BLOCK = 'block',

  /**
   * Диагностика
   */
  DIAGNOSTICS = 'diagnostics',

  /**
   * Компонентный ремонт
   */
  COMPONENT_REPAIR = 'component_repair',
}

export const RepairTypesTranslate: Record<string, string> = {
  [RepairTypes.BLOCK]: 'Блочный',
  [RepairTypes.DIAGNOSTICS]: 'Диагностика',
  [RepairTypes.COMPONENT_REPAIR]: 'Компонентный ремонт',
};

export const repair_types = Object.keys(RepairTypesTranslate).map((f: string) => ({
  text: RepairTypesTranslate[f],
  value: f,
}));

export enum RepairOperationType {
  /**
   * Гарантийный ремонт
   */
  GUARANTEE_REPAIR = 'guarantee_repair',

  /**
   * Негарантийный ремонт
   */
  NON_GUARANTEE_REPAIR = 'non_guarantee_repair',
}

export const RepairOperationTypeTranslate: Record<string, string> = {
  [RepairOperationType.GUARANTEE_REPAIR]: 'Гарантийный ремонт',
  [RepairOperationType.NON_GUARANTEE_REPAIR]: 'Негарантийный ремонт',
};

export const repair_operation_types = Object.keys(RepairOperationTypeTranslate).map(
  (f: string) => ({
    text: RepairOperationTypeTranslate[f],
    value: f,
  }),
);

export enum RepairReportDocs {
  /**
   * Карта учета ремонтов
   */
  CARD = 'repair_card',

  /**
   * Акт об оказании сервисных услуг
   */
  ACT = 'repair_act',
}

export const RepairReportDocsTranslate: Record<string, string> = {
  [RepairReportDocs.CARD]: 'Карта учета ремонтов',
  [RepairReportDocs.ACT]: 'Акт об оказании сервисных услуг',
};

export const repair_docs_checkboxes = Object.keys(RepairReportDocsTranslate).map((f: string) => ({
  label: RepairReportDocsTranslate[f],
  value: f,
}));
